let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9ws3L")).then(() => parcelRequire('gFzIn'));